// test1156
(1156 && 0);
